module.exports = __webpack_public_path__ + "img/5.8a0564e4.svg";